var _a;
import userAgent__default from "@play-co/user-agent";
import { unixTimestamp } from "../dateUtils.mjs";
import { trackedRequest } from "../trackedRequest.mjs";
const nfetch = ((_a = window.TLNative) == null ? void 0 : _a.utils.fetch) || window.fetch;
class LineConversionAPI {
  constructor(config) {
    this.config = config;
  }
  /**
   * Sends a conversion event to the LINE Conversion API
   *
   * https://conversion-api-docs.linebiz.com/en/#tag/LINE-Conversion-API-v1
   */
  async sendConversionEvent(opts) {
    const { tagID, tagAccessToken, channelID, conversionAPIEndpoint } = this.config.lineConversionAPIConfig;
    if (!tagID || !tagAccessToken || !channelID) {
      throw new Error("Missing configuration for LINE Conversion API.");
    }
    const deduplication_key = `${opts.userID}-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    const body = {
      web: {
        referrer: userAgent__default.referrer,
        user_agent: userAgent__default.string
      },
      event: {
        deduplication_key,
        event_timestamp: unixTimestamp(),
        event_name: opts.eventType,
        event_type: "conversion",
        source_type: "web"
      },
      user: {
        line_uid: opts.userID
      }
    };
    const click_id = new URLSearchParams(window.location.search).get(
      "ldtag_cl"
    );
    if (click_id) {
      body.user.click_id = click_id;
    }
    if (opts.revenue) {
      body.custom = {
        quantity: opts.revenue.quantity,
        currency: opts.revenue.currency,
        category: opts.revenue.category,
        value: opts.revenue.value
      };
    }
    await trackedRequest(
      nfetch,
      `${this.config.lineCORSProxyURL}/${conversionAPIEndpoint ?? "https://conversion-api.tr.line.me"}/v1/${tagID}/events`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Line-TagAccessToken": tagAccessToken,
          "X-Line-ChannelID": channelID
        },
        body: JSON.stringify([body]),
        tracking: {
          platform: "LINE",
          source: "GCInstant/LineConnectedGame.sendConversionEvent"
        }
      }
    ).catch(() => void 0);
  }
}
export {
  LineConversionAPI
};
